import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api';

const ContentContext = createContext({ content: null, settings: null, loading: true, refresh: () => {} });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const [contentRes, settingsRes] = await Promise.all([
        api.get('/content'),
        api.get('/settings/public'),
      ]);
      setContent(contentRes.data);
      setSettings(settingsRes.data);
    } catch (e) {
      console.error('Failed to load site content', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, settings, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
